module.exports = __webpack_public_path__ + "img/couples_06_H.12e7bb4a.jpg";